import React, { useState } from 'react'
import styled from 'styled-components'
import { Button, SearchIcon, Wrapper } from '@farewill/ui'
import { COLOR, GTR } from '@farewill/ui/tokens'
import { StyledInput } from 'components/Form/Input'

const StyledWrapper = styled(Wrapper)`
  position: relative;
`

const StyledSearchInput = styled(StyledInput)`
  padding: ${GTR.XS} ${GTR.XL} ${GTR.XS} ${GTR.S};
  width: 100%;
`

const StyledButton = styled(Button.Plain)`
  position: absolute;
  right: 2px;
  top: 2px;
  padding: 6px 6px 5px 6px;
  transition: background-color 0.3s ease-in-out;
  border-radius: 0 2px 2px 0;

  &:enabled {
    background-color: ${COLOR.ACCENT.PRIMARY};
  }

  &:disabled {
    color: ${COLOR.GREY.DARK};
  }
`

const SearchBox = ({
  onKeyDown,
  onChange,
  onFocus,
  onButtonClick,
}: {
  onKeyDown: React.KeyboardEventHandler<HTMLInputElement>
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  onFocus?: React.FocusEventHandler<HTMLInputElement>
  onButtonClick: React.MouseEventHandler<HTMLButtonElement>
}): React.ReactElement => {
  const [value, setValue] = useState('')

  return (
    <StyledWrapper>
      <StyledSearchInput
        type="text"
        placeholder="Search"
        onKeyDown={onKeyDown}
        onChange={(event) => {
          setValue(event.target.value)
          if (onChange) onChange(event)
        }}
        onFocus={onFocus}
        value={value}
      />
      <StyledButton type="submit" onClick={onButtonClick} disabled={!value}>
        <SearchIcon size="L" />
      </StyledButton>
    </StyledWrapper>
  )
}

export default SearchBox
